export const SET_SAVED_ACTION = 'app/SET_SAVED_ACTION';

export const setSavedAction = payload => ({
  type: SET_SAVED_ACTION,
  payload,
});
